import { apiClient, ApiResponse } from './client';

const API_URL = '/instacart';

export interface StoreLocation {
  name: string;
  longitude: number;
  latitude: number;
  rank: number;
  logoUrl?: string;
}

export const getStoreLocations = async (
  session_id: string,
  latitude: number,
  longitude: number,
  max_rank: number = 5
): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: `${API_URL}/store_locations`,
    data: { 
      session_id, 
      latitude, 
      longitude, 
      max_rank 
    }
  });
}; 

export const updateBatchFinderServiceLocation = async (
  session_id: string,
  latitude: number,
  longitude: number,
  is_real_location: boolean,
  display_name: string
): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/instacart/step/settings/update',
    data: {
      session_id,
      location: { latitude, longitude, is_real_location, display_name },
    },
  });
};
